<template>
  <div class="background">
    <div class="login_box">
      <!-- 头部：logo + 标题 -->
      <div class="login_header">
        <el-image class="logo" :src="require('../assets/image/logo.png')"></el-image>
        <h2 class="title">华连生足部健康管理系统</h2>
        <p class="slogan">您的双脚 · 我来呵护</p>
      </div>
      <!-- 登录表单 -->
      <el-form :model="loginForm" :rules="loginFormRules" ref="loginForm" @keyup.enter.native="login()">
        <el-form-item prop="loginId">
          <el-input
            placeholder="请输入手机号"
            prefix-icon="iconfont icon-yonghu"
            v-model="loginForm.loginId"
            @blur="modifyPhone"
            onkeyup="value=value.replace(/[^\d]/g,'')">
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            placeholder="请输入密码"
            prefix-icon="iconfont icon-tianchongxing-"
            v-model="loginForm.password"
            type="password"
            show-password>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="loginForm.shopId" placeholder="请选择机构" style="width: 100%">
            <el-option
              v-for="org in orgList"
              :key="org.id"
              :label="org.orgName"
              :value="org.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="form_options">
            <el-checkbox v-model="loginForm.isRemember">记住密码</el-checkbox>
            <div>
              <router-link to="/registry" class="link">注册账号</router-link>
              <a @click="showForgetPasswordDialog" class="link">忘记密码</a>
            </div>
          </div>
        </el-form-item>
        <el-button class="btn_p" type="primary" @click="login()">登 录</el-button>
      </el-form>
    </div>
    <!-- 忘记密码 -->
    <el-dialog
      title="忘记密码"
      :visible.sync="forgetPasswordDialogVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-form :model="updateForm" :rules="loginFormRules" ref="updateForm" label-width="100px">
        <el-form-item  prop="updatePhone" label="手机号:">
          <el-input id="updatePhone" size="mini" style="width: 90%" v-model="updateForm.updatePhone"></el-input>
        </el-form-item>
        <el-form-item  prop="updatePassword" label="新密码:">
          <el-input id="updatePassword" size="mini" style="width: 90%" v-model="updateForm.updatePassword"></el-input>
        </el-form-item>
        <el-form-item  prop="updateCode" label="验证码:">
          <el-input id="updateCode" size="mini" style="width: 70%" v-model="updateForm.updateCode"></el-input>
          <el-button size="mini" style="width: 20%" @click="getCheckCode">获取验证码</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" style="width: 100px" @click="closeForgetPasswordDialog">取 消</el-button>
        <el-button size="mini" style="width: 100px" @click="updateUserPassword">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data() {
      return {
        loginForm:{
          loginId: '',
          password: '',
          isRemember:false,
          shopId:''
        },
        loginPhone:'',
        loginFormRules:{
          loginId: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { min: 11, max:11, message: '请正确输入11位手机号码', trigger: 'blur' }
          ],
          password:[
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min:6,max:18, message: '请输入6位及以上的密码', trigger: 'blur'}
          ],
          updatePhone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
            { min: 11, max:11, message: '请正确输入11位手机号码', trigger: 'blur' }
          ],
          updatePassword: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {min:6,max:18, message: '请输入6位及以上的密码', trigger: 'blur'}
          ],
          updateCode: [
            {required: true, message: '请输入验证码', trigger: 'blur'}
          ],
        },
        orgList:[],
        forgetPasswordDialogVisible:false,
        updateForm:{
          updatePhone:'',
          updatePassword:'',
          updateCode:''
        }
    }
  },
    methods: {
      modifyPhone(){
        if (this.loginPhone !== this.loginForm.loginId){
          this.loginForm.password = '';
        }
        this.loadOrg();
      },
      async login() {
        if (this.loginForm.shopId === ''){
          return this.$message.warning("请选择机构！")
        }
        if (this.loginForm.password === ''){
          return this.$message.warning("密码不能为空！")
        }
        if (this.loginForm.isRemember === true){
          this.setCookie(this.loginForm.loginId, this.loginForm.password);
        } else {
          this.closeCookie();
        }
        const {data:res} = await this.$http.post('login', this.loginForm);
        if (res.code === 200){
          this.$message.success(res.msg);
          window.sessionStorage.setItem('orgId',res.data.orgId);
          window.sessionStorage.setItem('currentOrgId',res.data.orgId);
          window.sessionStorage.setItem('currentOrgPurchaseLevel',res.data.purchaseLevel);
          window.sessionStorage.setItem('orgName',res.data.orgName);
          window.sessionStorage.setItem('userName',res.data.userName);
          window.sessionStorage.setItem('userId',res.data.id);
          window.sessionStorage.setItem('password',res.data.password);
          window.sessionStorage.setItem('token',res.data.token);
          window.sessionStorage.setItem('orgLevel',res.data.orgLevel);
          window.sessionStorage.setItem('authorities',res.data.authorities);
          window.sessionStorage.setItem('moLingRate',res.data.moLingRate);
          window.sessionStorage.setItem('areaId',res.data.parentId);
          window.sessionStorage.setItem('authName',res.data.dataAuth.authName);
          window.sessionStorage.setItem('groupValue',res.data.dataAuth.groupValue);
          await this.$router.push('/home');
        } else if (res.code === 404) {
          this.$message.error(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      },
      setCookie(loginId,password){
        window.document.cookie = "loginId=" + loginId;
        window.document.cookie = "password="+ password;
        window.document.cookie = "isRemember="+ this.loginForm.isRemember;
      },
      closeCookie(){
        this.setCookie("","");
      },
      getCookie(){
        if (window.document.cookie.length > 0){
          let arr = document.cookie.split(";")
          for (let i = 0; i < arr.length; i++){
            let cookieObject = arr[i].split("=");
            if (cookieObject[0].trim() === 'loginId'){
              this.loginForm.loginId = cookieObject[1];
              this.loginPhone = cookieObject[1];
            } else if (cookieObject[0].trim() === 'password'){
              this.loginForm.password = cookieObject[1];
            } else if (cookieObject[0].trim() === 'isRemember'){
                this.loginForm.isRemember = Boolean(cookieObject[1]);
            }
          }
        }
        if (this.loginForm.loginId != ''){
          this.loadOrg();
        }
      },
      async loadOrg(){
        const {data:res} = await this.$http.get(`/login/orgList/${this.loginForm.loginId}`)
        if (res.code === 200){
          this.orgList = res.data || [];
          // 等选项渲染完成后再回填选中值，否则 el-select 匹配不到 option 会直接显示数字 id
          this.$nextTick(() => {
            const exists = this.orgList.some(org => org.id == this.loginForm.shopId);
            this.loginForm.shopId = exists ? this.loginForm.shopId : (this.orgList.length ? this.orgList[0].id : '');
          });
        }
      },
      showForgetPasswordDialog(){
        this.forgetPasswordDialogVisible = true;
      },
      closeForgetPasswordDialog(){
        this.forgetPasswordDialogVisible = false;
      },
      async getCheckCode(){
        if (this.updateForm.updatePhone == ''){
          return this.$message.warning('请输入手机号');
        }
        const {data:res} = await this.$http.get(`/users/getCode/${this.updateForm.updatePhone}`);
        if (res.code === 200){
          return this.$message.success("验证码已发送至您的手机");
        }
      },
      async updateUserPassword(){
        const {data:res} = await this.$http.post('/editUserPassword', this.updateForm)
        if (res.code === 200){
          this.$message.success('修改成功！');
          this.closeForgetPasswordDialog();
        } else {
          this.$message.warning(res.msg);
        }
      },
    },
  mounted() {
      this.getCookie();
  }
}
</script>

<style scoped>
  .background{
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url("../assets/image/login.png");
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-y: auto;
  }

  /* 登录卡片 */
  .login_box{
    width: 420px;
    box-sizing: border-box;
    padding: 40px 40px 32px;
    background: rgba(255, 255, 255, 0.96);
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.18);
    animation: slideDown 0.6s ease;
  }

  @keyframes slideDown{
    from{ opacity: 0; transform: translateY(-24px); }
    to{ opacity: 1; transform: translateY(0); }
  }

  /* 头部 */
  .login_header{
    text-align: center;
    margin-bottom: 28px;
  }

  .logo{
    width: 64px;
    height: 64px;
    margin-bottom: 10px;
  }

  .title{
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #303133;
    letter-spacing: 1px;
  }

  .slogan{
    margin: 10px 0 0;
    font-size: 13px;
    color: #909399;
    letter-spacing: 3px;
  }

  /* 输入框统一美化 */
  .login_box >>> .el-input__inner{
    height: 44px;
    line-height: 44px;
    border-radius: 8px;
    transition: all 0.25s;
  }

  .login_box >>> .el-input__inner:focus{
    border-color: #409EFF;
    box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
  }

  .login_box >>> .el-input__icon{
    line-height: 44px;
  }

  .login_box >>> .el-input__prefix{
    left: 8px;
    font-size: 16px;
    color: #909399;
  }

  .login_box >>> .el-input--prefix .el-input__inner{
    padding-left: 36px;
  }

  /* 记住密码 / 链接 */
  .form_options{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .link{
    color: #409EFF;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    margin-left: 16px;
    transition: color 0.2s;
  }

  .link:hover{
    color: #66b1ff;
  }

  /* 登录按钮 */
  .btn_p{
    width: 100%;
    height: 44px;
    margin-top: 2px;
    font-size: 16px;
    border-radius: 8px;
    border: none;
    background: linear-gradient(135deg, #409EFF, #2b7de9);
    transition: all 0.3s;
  }

  .btn_p:hover{
    background: linear-gradient(135deg, #53a8ff, #3a8ee6);
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(64, 158, 255, 0.4);
  }

  .btn_p:active{
    transform: translateY(0);
    box-shadow: 0 4px 10px rgba(64, 158, 255, 0.3);
  }

  .dialog-footer{
    display: flex;
    margin: 10px 10px 10px 0;
    justify-content: center;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue